import React from 'react';
const WidthContext = React.createContext({ width: 600 });
export const WidthProvider = WidthContext.Provider;
export const useWidth = () => React.useContext(WidthContext);
export const useRemainingWidth = ({ border, borderLeft, borderRight, padding, paddingLeft, paddingRight, round, width, }) => {
    const { width: availableWidth } = useWidth();
    return React.useMemo(() => {
        let adjustedWidth = availableWidth;
        if (width?.endsWith('%')) {
            adjustedWidth = (availableWidth * parseFloat(width)) / 100;
        }
        else if (width?.endsWith('px')) {
            adjustedWidth = parseInt(width, 10);
        }
        const paddingList = (padding || '').split(' ');
        const paddingLeftValue = parseInt(paddingLeft || paddingList[3] || paddingList[1] || paddingList[0] || '0', 10);
        const paddingRightValue = parseInt(paddingRight || paddingList[1] || paddingList[0] || '0', 10);
        const borderLeftValue = extractWidthInPixels(borderLeft || border, 0);
        const borderRightValue = extractWidthInPixels(borderRight || border, 0);
        const result = Math.max(adjustedWidth -
            paddingLeftValue -
            paddingRightValue -
            borderLeftValue -
            borderRightValue, 0);
        return {
            width: round ? Math.floor(result) : result,
        };
    }, [
        width,
        availableWidth,
        padding,
        paddingLeft,
        paddingRight,
        border,
        borderLeft,
        borderRight,
        round,
    ]);
};
function extractWidthInPixels(cssValue, defaultValue = 0) {
    const valueWithPx = (cssValue || '').split(' ').find((_) => _.includes('px'));
    return parseInt(valueWithPx, 10) || defaultValue;
}
//# sourceMappingURL=width-context.js.map